module.exports = __webpack_public_path__ + "img/pimg15.cf673bee.png";